<template>
  <app-view-template-industry-cases class="app-view-template-industry-cases-financial"
          title="Change is here - is your game plan ready?"
          :brands="brands">

    <!-- Case 1 -->
    <case-visa />

    <case-jyske-bank />

  </app-view-template-industry-cases>
</template>

<script>
  /* Templates */
  import AppViewTemplateIndustryCases from '@/components/layout/templates/view/AppViewTemplateIndustryCases';

  /* Cases */
  import CaseJyskeBank from '@/components/cases/financial/JyskeBank';
  import CaseVisa from '@/components/cases/other/Visa';

  /* Models */
  import Brands from '@/models/brands';

  export default {
      name: 'FinancialCases',

      components: {
        AppViewTemplateIndustryCases, CaseJyskeBank, CaseVisa,
      },

      data: function() {
        return {
          brands: {
            title: 'Featured cases',
            items: [],
          },
        }
      },

      methods: {
        getBrands() {
          this.brands.items = new Brands().getIndustries('Financial');
        }
      },

      created() {
        this.getBrands();
      },
  }
</script>

<style lang="scss">
  .app-view-template-industry-cases-financial {
    min-height: calc(100vh - 100px);

    @media (min-width: $lgBreakpoint) {
      .banners {
        background-image: url("../../../assets/images/industries/banners/financial.jpg");
      }
    }
  }
</style>
